import script from "./InboundMailItemWidget.vue?vue&type=script&lang=ts&setup=true"
export * from "./InboundMailItemWidget.vue?vue&type=script&lang=ts&setup=true"

import "./InboundMailItemWidget.vue?vue&type=style&index=0&id=3158fd18&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3158fd18"]])

export default __exports__